import { createFeatureSelector, createSelector } from "@ngrx/store";
import { AppSettings } from "src/components/shared-components/class/general-classes/app-settings";
import { ScenariosState } from "../reducers/scenario.reducer";

/**
 * Selector for scenarios list
 */
export const listScenarios = createFeatureSelector<ScenariosState>(
    AppSettings.KEY_SCENARIOS
);

/**
 * Selector for the HTTP status code of the last failed scenario API call (-1 means no error).
 */
export const scenariosErrorCode = createSelector(
    listScenarios,
    (state: ScenariosState) => state?.errorCode ?? -1
);
